// @ts-nocheck
import { bool, element, node, oneOfType, string } from 'prop-types'

const IGNORED_EMPTY_PROPS = ['className', 'id', 'label']

const WrapIfNeeded = ({
  element: Element,
  forceRender = null,
  children = null,
  ...rest
}) => {
  const propsEntries = Object.entries(rest).filter(
    ([name, value]) =>
      value != null &&
      !(IGNORED_EMPTY_PROPS.includes(name) && !String(value).trim())
  )

  if (propsEntries.length === 0 && forceRender !== true) {
    return children
  }

  return <Element {...Object.fromEntries(propsEntries)}>{children}</Element>
}

WrapIfNeeded.propTypes = {
  element: oneOfType([string, element]).isRequired,
  forceRender: bool,
  children: node,
}

WrapIfNeeded.defaultProps = {
  children: null,
  forceRender: null,
}

export default WrapIfNeeded
